import { render, staticRenderFns } from "./hszBanKuai.vue?vue&type=template&id=3a3a2754&scoped=true"
import script from "./hszBanKuai.vue?vue&type=script&lang=js"
export * from "./hszBanKuai.vue?vue&type=script&lang=js"
import style0 from "./hszBanKuai.vue?vue&type=style&index=0&id=3a3a2754&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3a2754",
  null
  
)

export default component.exports